import posthog from "posthog-js";
import { setPostHog } from "./posthog";

export const setOsano = () => {
  if (!window.Osano?.cm) {
    console.error("Osano Consent Manager is not loaded.");
    return;
  }

  window.Osano.cm.addEventListener("osano-cm-consent-saved", (consent) => {
    if (consent.ANALYTICS === "ACCEPT") {
      setPostHog();
      posthog.opt_in_capturing();
    } else {
      posthog.opt_out_capturing();
    }
  });
};
